import _ from './translate.js';
import Presentation from './presentation.js';
import nav from './navigate.js';
import UploadStep from './uploadStep.js';
import Size from './size.js';
import Retouch from './retouch.js';
import SelectProduct from './selectProduct.js';
import GotoProduct from './gotoProduct.js';
import CropImageViewport from './cropImageViewport.js';
import CropImageToolbar from './cropImageToolbar.js';
import ZoomPanToolbox from './ZoomPanToolbox.js';
import StartOver from './startover.js';
import Paper from './paper.js';
import events from './event.js';
import imageHelper from './imageHelper.js';
import Logger from './logger.js';
import Storage from './storage.js';

class Customizer {
    popupContentDiv = null; // The content div of the popup
    wrapperDiv = null;
    contentDiv = null;
    cropperDiv = null;
    cropperToolbarDiv = null; // Toolbar for the cropper
    cropper = null;
    cropperPreviewDiv = null;
    cropperToolbar = null;
    zoomPanToolbox = null;
    topNavigationDiv = null;
    bottomNavigationDiv = null;
    options = null; // Options for the customizer
    isReady = false; // Flag to indicate if customizer is fully initialized
    readyPromise = null; // Promise that resolves when customizer is ready

    constructor(popupContentDiv, options = null) {
        this.popupContentDiv = popupContentDiv;
        if (!this.popupContentDiv) {
            Logger.error('Customizer constructor loading failed.');
            return;
        }
        this.options = options || {}; // Store options for later use
        this.readyPromise = this.init();
    }

    async init() { // Initialize the customizer

        // create cropper wrapper div
        this.cropperDiv = document.createElement('div');
        this.cropperDiv.classList.add('mscp-crop-wrapper');
        this.popupContentDiv.appendChild(this.cropperDiv);

        // create cropper preview div
        this.cropperPreviewDiv = document.createElement('div');
        this.cropperPreviewDiv.classList.add('mscp-crop-preview');
        this.cropperDiv.appendChild(this.cropperPreviewDiv);

        // create cropper toolbar
        this.cropperToolbarDiv = document.createElement('div');
        this.cropperToolbarDiv.classList.add('mscp-crop-toolbar');
        this.cropperDiv.appendChild(this.cropperToolbarDiv);


        // outer content wrapper div
        this.wrapperDiv = document.createElement('div');
        this.wrapperDiv.classList.add('mscp-wrapper');
        // this.wrapperDiv.dataset.activeStep = 'customizer';
        this.wrapperDiv.innerHTML = "";
        this.popupContentDiv.appendChild(this.wrapperDiv);

        // create top navigation
        this.topNavigationDiv = document.createElement('div');
        this.topNavigationDiv.classList.add('mscp-top-navigation-wrapper');
        // this.wrapperDiv.appendChild(this.topNavigationDiv);

        // create content div
        this.contentDiv = document.createElement('div');
        this.contentDiv.classList.add('mscp-content-wrapper');
        this.wrapperDiv.appendChild(this.contentDiv);

        // create bottom navigation
        this.bottomNavigationDiv = document.createElement('div');
        this.bottomNavigationDiv.classList.add('mscp-bottom-navigation-wrapper');
        this.wrapperDiv.appendChild(this.bottomNavigationDiv);


        this.cropper = new CropImageViewport(this.cropperPreviewDiv, {
            ...this.options,
        });
        this.cropperToolbar = new CropImageToolbar(this.cropperToolbarDiv, {
            ...this.options,
        });

        this.zoomPanToolbox = new ZoomPanToolbox(this.cropper, this.contentDiv);

        await this.initPopup();

        // Mark as ready AFTER everything is initialized
        this.isReady = true;
        events.trigger('customizerReady');

        events.add('stepChanged', (step) => { this.activateLoading(); }); // Reset adjust mode when changing steps
    }

    activateLoading() {
        this.popupContentDiv.classList.add('loading');
    }

    deactivateLoading() {
        this.popupContentDiv.classList.remove('loading');
    }

    /**
     * Determines which step to show based on current state and options.
     * This is used both on initial load and when reopening the popup.
     */
    async determineInitialStep(options = {}) {
        // Wait until customizer is fully ready
        if (!this.isReady) {
            await this.readyPromise;
        }

        // in edit mode, go to paper step directly
        // if (options.openInEdit) {
        //     events.trigger('changeStep', 'paper');
        // }
        // // not in edit mode, but image already uploaded
        // else 
        if (await imageHelper.getActiveImage()) {
            // Check if we have an active image
            if (Storage.get('activeImageID')) {
                // events.trigger('changeStep', 'paper');
                events.trigger('openStartOver');
                events.trigger('setSize', Storage.get('size'));
            }
        }
        // No image uploaded yet and not in edit mode
        else {
            events.trigger('reInitUpload');
            // events.trigger('showLoadingOverlay', 'paper');
        }
    }



    async initPopup() {
        new StartOver(this.popupContentDiv); // Initialize the start over module
        nav.init(this.topNavigationDiv, this.bottomNavigationDiv, this.popupContentDiv); // Initialize the navigator module
        // upload.init(this.contentDiv, this.cropperPreviewDiv); // Initialize the upload module

        // Add event listener for determining initial step
        events.add('determineInitialStep', async (options) => {
            await this.determineInitialStep(options || this.options);
        });

        // Determine which step to show on initial load
        await this.determineInitialStep(this.options);

        // do following in other thread to avoid blocking the UI
        setTimeout(() => {
            new UploadStep(this.contentDiv, this.cropperDiv); // Pass cropperDiv so upload button can be positioned correctly
            // När en bild sparas lokalt, visa upload overlay tills den är uppladdad
            events.add('newImageLocalSaved', ({ status }) => {
                // Visa upload overlay under uppladdning
                events.trigger('showLoadingOverlay', 'upload');
                Logger.debug('Image saved locally, showing upload overlay. Status:', status);
            });
            new Presentation(this.contentDiv, this.options);
            new Paper(this.contentDiv); // Initialize the paper module
            new Size(this.contentDiv); // Initialize the size module
            new Retouch(this.contentDiv); // Initialize the retouch module
            new SelectProduct(this.contentDiv); // Initialize the select product module
            new GotoProduct(this.contentDiv); // Initialize the goto product module
        }, 0);
    }

}

export default Customizer;